import type { TenantClinicRoute } from '../../types';
import { KEILOG_DESIGN_GUIDELINE_PATH } from '../pages/design-guideline/constants';

/**
 * HIT-11538 デザインガイドライン — a review page with no menu entry.
 *
 * Registered only when `VITE_ENABLE_DESIGN_TEMPLATE` is exactly "true" at build
 * time; otherwise the path does not exist and a direct visit falls through to
 * the tenant's NotFound. Core's P1 `design-template` stays its own route either
 * way; this path does not shadow it.
 *
 * The comparison is written inline, not behind `isDesignGuidelineEnabled`: Vite
 * turns `import.meta.env.VITE_ENABLE_DESIGN_TEMPLATE` into a literal, Rollup
 * folds the condition, and a build without "true" ships neither this route nor
 * the guide's chunks. Keep the two checks in step.
 */
export const keilogDesignGuidelineRoutes: TenantClinicRoute[] =
  import.meta.env.VITE_ENABLE_DESIGN_TEMPLATE === 'true'
    ? [
        {
          path: KEILOG_DESIGN_GUIDELINE_PATH.slice(1),
          component: () => import('./DesignGuidelineRoute'),
        },
      ]
    : [];
